import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import '@/assets/styles/components/order-confirm-status-mobile.scss'
import { getSafe } from '@/helpers/global';
import icon_success from '@/assets/images/icons/icon_success.png'
import icon_fail from '@/assets/images/icons/icon_fail.png'
// import trade_icon_amend from '@/assets/images/icons/trade_icon_amend_normal.png'
// import trade_icon_cancel from '@/assets/images/icons/trade_icon_cancel_normal.png'
import { openOrderCancelDialog, openOrderJournalDetailDialog, openOrderModifyDialog } from '@/actions/app';
import { formatFunctions, utilsFunction } from '@/helpers/functions';
import { dataType } from '@/constants/data-type'
import { ORDER_MODE, REFRESH_DATA, ORDER_TYPE} from '@/constants/app';
import { SERVICES_RESP } from '@/configurations';
import { orderActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import Tips from '@/components/Tips/Tips';
import { tipsType } from '@/constants/tips-type';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';

class OrderConfirmStatusMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderInformation: [],
      failReason: '',
      status: '-',
      // isShowPrice:true,
      errMsgList:[],
      orderFeesDetailed:[],
      grossAmount:'-'
    }
  }

  render() {
    const { language, orderResult, mode, isCancel} = this.props
    const { orderInformation, failReason, status,errMsgList,orderFeesDetailed , grossAmount } = this.state
    const isSuccess = orderResult.isSuccess === 'Y'
    return (
      <React.Fragment>
        <div className="order-confirm-status-box-mobile" style={isSuccess ? { paddingTop:'26px' } : { paddingTop:'0' }}>
          <header>
          {isSuccess && <div className="note">
            <div className="note-order-status">
              {getSafe(() => language.order_confirm_status)} :  {language[`order_status_${status.toLowerCase()}`]} ({status})
            </div>
            <div className={classnames('c-status c-status-success')}>
                <img src={icon_success} alt="icon_success" />{getSafe(() => language.order_confirm_received_instruction)}
            </div>
            <div className="note-content">
              {getSafe(() => language.order_confirm_note)}
            </div>
          </div>
          }
            {!isSuccess &&               
              <React.Fragment>
                {
                  errMsgList && errMsgList .length > 0 && errMsgList.map((item,index)=> <Tips key={index} type={tipsType.error}>{item}</Tips>)
                }
                <div className={classnames('c-status c-status-fail')}>
                  <img src={icon_fail} alt="icon_fail" />{getSafe(() => language.order_failed)}
                </div>
              </React.Fragment>
              }
            
          </header>
          <section>
          {isSuccess && <div className="order-information-item">
              <span>{getSafe(() => language.common_order_id)}</span>
              <span>{orderResult.orderGroupID}</span>
            </div>}
            {orderInformation.map(item =>
              <div key={item.label} className={classnames("order-information-item", item.classStyle)}>
                <label>{item.label}</label>
                <span>{item.value}</span>
              </div>
            )}
          </section>
          {isSuccess && isCancel !== 'Y' && orderFeesDetailed.length > 0 && <span style={{lineHeight:'40px',paddingLeft:'10px'}}>{getSafe(() => language.common_commission_fees)}</span>}
          {isSuccess && isCancel !== 'Y' && orderFeesDetailed.length > 0 && <section>{orderFeesDetailed}</section>}
          {isSuccess && 
              <div className={classnames("gross-amount-item")}>
                <label>{language.common_gross_amount}</label>
                <span>{grossAmount}</span>
              </div>}
          {isSuccess
            ? <footer>
              <div className="action-right">
                {mode !== ORDER_MODE.CANCEL &&
                  <React.Fragment>
                    {/* <button onClick={this.handleAmend}><img src={trade_icon_amend} alt="trade icon amend" />{getSafe(() => language.common_modify)}</button>
                    <button onClick={this.handleCancel}><img src={trade_icon_cancel} alt="icon_success" />{getSafe(() => language.common_cancel)}</button> */}
                  </React.Fragment>}
                <button className="info" onClick={this.handleOpenDetail}>{language.order_journal_detail_title}</button>
              </div>
              {/* <button className={classnames("confirm-btn", "confirm")} onClick={() => this.props.onClose()}>
                {getSafe(() => language.common_confirm)}
              </button> */}
            </footer>
            : <footer>
              {/* <button className={classnames("confirm-btn", "confirm")} onClick={() => this.props.onClose(false)}>
                {getSafe(() => language.order_trade_again)}
              </button> */}
            </footer>
          }
        </div>
      </React.Fragment>
    )
  }

  handleAmend = () => {
    this.props.onClose()
    openOrderModifyDialog(this.props.orderResult)
  }

  handleCancel = () => {
    this.props.onClose()
    openOrderCancelDialog(this.props.orderResult)
  }

  handleOpenDetail = () => {
    // this.props.onClose()
    // openOrderJournalDetailDialog(this.props.orderResult,null, false, true, false);
    mobileSubLayoutAction.openOrderJournalDetail(this.props.orderResult ,true)
  }

  computeOrderInformation(orderData, orderResult,orderFees) {
    const { language, currentTradingAccount, mode, instrumentInfo } = this.props;
    let orderInformation;
    let marketID = orderData.marketID
    const isSuccess = orderResult.isSuccess === 'Y';
    const orderType = orderData.orderType.value ? orderData.orderType.value : orderData.orderType;
    let quantity = orderData.quantity !== undefined ? orderData.quantity : orderData.qty;
    let unit = orderData.unit;
    let isBuy;
    let fees;
    let grossAmount;
    if (marketID === 'FUND') {
      if(this.props.isCancel){
        isBuy = (orderData.bs == 'B')
      }else {
        isBuy = Boolean(orderData.isAllowBuy)
      }
    } else {
      isBuy = orderData.isBuy ? orderData.isBuy : orderResult.bs === 'B'
    }
    if (mode === ORDER_MODE.MODIFY) {
      quantity = orderResult.newQty
    }
    let price = orderData.price;
    if (mode === ORDER_MODE.MODIFY) {
      price = orderResult.newPrice
    }
    // const name = orderData.instrumentChineseShortName ? orderData.instrumentChineseShortName : orderData.instrumentShortName;
    let name = ''
    if(language.title === 'zh_TW' || language.title === 'zh_CN'){
      if(orderData.instrumentChineseName){
        name = orderData.instrumentChineseName
      }else{
        name = orderData.instrumentName
      }
    }else{
      name = orderData.instrumentName
    }
    if(orderData.marketID == "FUND" && orderFees?.feesList){
      fees = orderData.isAllowBuy ?  getSafe(() => orderData.currencyID, '') +' '+ orderFees?.feesList?.filter(item => {return item.feeID == 'FUND.SUB'})[0]?.amount :  getSafe(() => orderData.currencyID, '') +' '+ orderFees?.feesList?.filter(item => {return item.feeID == 'FUND.REDEM'})[0]?.amount
    }else if((orderResult.feeAmt !='null' && orderResult.feeAmt)){
      fees = getSafe(() => orderData.currencyID, '') +" " + formatFunctions.dataFormat(orderResult.feeAmt, dataType.CASH)
    }else if(orderFees?.feeAmt !='null' && orderFees?.feeAmt){
      fees = getSafe(() => orderData.currencyID, '') + " " +formatFunctions.dataFormat(orderFees.feeAmt, dataType.CASH)
    }else{
      fees = '-'
    }
    if(orderFees?.feesList){
      if(orderData.marketID == "FUND"){
        grossAmount = orderData.isAllowBuy ? price * quantity + (orderFees.feeAmt - 0) : price * quantity - orderFees.feeAmt
      }else{
        grossAmount = orderData.isBuy ? price * quantity + (orderFees.feeAmt - 0) : price * quantity - orderFees.feeAmt
      }
    }else if((orderResult.holdAmount !='null' && orderResult.holdAmount)){
      grossAmount = orderResult.holdAmount
    }
    this.setState({grossAmount:getSafe(() => orderData.currencyID, '') + " " + formatFunctions.dataFormat(grossAmount, dataType.CASH)})
    const goodTillDate = orderResult.goodTillDate ? orderResult.goodTillDate : orderData.goodTillDate.value;
    const stopType = getSafe(() => orderData.stopType.value, orderData.stopOrderType);
    const stopPrice = orderData.stopPrice;
    if (marketID === "FUND") {
      orderInformation = [
        { label: language.place_order_dialog_cash_account, value: currentTradingAccount.tradingAccountID},

        {
          label: language.common_order_direction,
          value: language[`${isBuy ? 'common_funds_subscription' : 'common_funds_redemption'}`],
          classStyle: `${isBuy ? 'order-direction-buy' : 'order-direction-sell'}`
        },

        // (marketID === "FUND" ? '' : { label: language.common_order_type, value: language[`order_type_${orderType.toLowerCase()}`] ? language[`order_type_${orderType.toLowerCase()}`] : '-' }),

        // { label:  language.funds_instrument_id, 
        //   value: `${orderData.instrumentID}` },

        { label: language.common_order_time, value: formatFunctions.dataFormat(orderResult.inputTime, dataType.LONG_DATE) },
        { label:language.common_funds_market_id,
          value:`${orderData.marketID}` },     
        { label: language.funds_instrument_id, 
          value: `${orderData.instrumentID}` },
        { label: language.common_currency, value: getSafe(() => orderData.currencyID, '') },
        { label:language.funds_instrument_name , value: name , classStyle:'order-direction-name' },
        {
          label: language.common_good_till_date,
          value: goodTillDate ? formatFunctions.dataFormat(goodTillDate, dataType.SHORT_DATE) : '-'
        },
        {
          label: language.common_price,
          value: `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(orderData.price, dataType.STOP_PRICE)}` 
        },
        {
          label: language.common_quantity,
          value: `${formatFunctions.dataFormat( quantity , dataType.FUNDS_QUANTITY)} ${language.fund_Unit.format((language.lang === 'en_US' && quantity > 1) ? 's' : '')}`
        },
        // (marketID === "FUND" ? '' : {
        //   label: language.common_stop_type,
        //   value: getSafe(() => language[`order_stop_price_type_${stopType}`], '-')
        // }),

      //  ( marketID === "FUND" ? '' : {
      //     label: language.common_stop_price,
      //     value: stopPrice
      //         ? `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(stopPrice, marketID === "FUND" ?dataType.STOP_PRICE:dataType.CURRENCY)}`
      //         : '-'
      //   }),

        // ( marketID === "FUND" ? "" :
        //  {label: language.common_commission_fees,
        //   value: orderResult.feeAmt + '' ? `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(orderResult.feeAmt, dataType.CASH)}` : '-'}
        // ),

        
          ( 
            { label: orderData.isAllowBuy ? language.common_funds_subscription_F  : (orderData.bs === 'B' ? language.common_funds_subscription_F : language.common_funds_redemption_F),
            value: fees }
          ),

        
      ]
    } else if(isSuccess) {
      orderInformation = [
        { label: language.place_order_dialog_cash_account, value: currentTradingAccount.tradingAccountID ? currentTradingAccount.tradingAccountID : currentTradingAccount.label},
        { label: language.common_order_type, value: language[`order_type_${orderType.toLowerCase()}`] },

        {
          label: language.common_order_direction,
          value: language[`${isBuy ? 'common_buy' : 'common_sell'}`],
          classStyle: `${isBuy ? 'order-direction-buy' : 'order-direction-sell'}`
        },
        { label: language.common_symbol, value: `${orderData.marketID}.${orderData.instrumentID}` },
        { label: language.common_name, value: name },
        {
          label: language.common_trading_price,
          value: `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(price, dataType.CURRENCY)}`
        },
        {
          label: language.common_trading_quantity,
          value: `${formatFunctions.dataFormat(quantity, dataType.NUMBER)} ${language.common_share.format((language.lang === 'en_US' && quantity > 1) ? 's' : '')}`
        },
        
        {
          label: language.common_stop_type,
          value: getSafe(() => language[`order_stop_price_type_${stopType}`], '-')
        },
        {
          label: language.common_stop_price,
          value: stopPrice
              ? `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(stopPrice, dataType.CURRENCY)}`
              : '-'
        },
        {
          label: language.common_good_till_date,
          value: goodTillDate ? formatFunctions.dataFormat(goodTillDate, dataType.SHORT_DATE) : '-'
        },
        { label: language.common_currency, value: getSafe(() => orderData.currencyID, '') },
        { label: language.common_order_time, value: formatFunctions.dataFormat(orderResult.inputTime, dataType.LONG_DATE) },
        {
          label: language.common_commission_fees,
          value: fees
        },
      ]
    } else {
      orderInformation = [
        { label: language.place_order_dialog_cash_account, value: currentTradingAccount.tradingAccountID ? currentTradingAccount.tradingAccountID : currentTradingAccount.label},
        { label: language.common_order_type, value: language[`order_type_${orderType.toLowerCase()}`] },

        {
          label: language.common_order_direction,
          value: language[`${isBuy ? 'common_buy' : 'common_sell'}`],
          classStyle: `${isBuy ? 'order-direction-buy' : 'order-direction-sell'}`
        },
        { label: language.common_symbol, value: `${orderData.marketID}.${orderData.instrumentID}` },
        { label: language.common_name, value: name },
        {
          label: language.common_trading_price,
          value: `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(price, dataType.CURRENCY)}`
        },
        {
          label: language.common_trading_quantity,
          value: `${formatFunctions.dataFormat(quantity, dataType.NUMBER)} ${language.common_share.format((language.lang === 'en_US' && quantity > 1) ? 's' : '')}`
        },
        
        {
          label: language.common_stop_type,
          value: getSafe(() => language[`order_stop_price_type_${stopType}`], '-')
        },
        {
          label: language.common_stop_price,
          value: stopPrice
              ? `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(stopPrice, dataType.CURRENCY)}`
              : '-'
        },
        { label: language.common_good_till_date, value: goodTillDate ? goodTillDate.value : '-' },
        { label: language.common_currency, value: getSafe(() => orderData.currencyID, '') },
        { label: language.common_order_time, value: formatFunctions.dataFormat(orderResult.inputTime, dataType.LONG_DATE) },
        {
          label: language.common_commission_fees,
          value: fees
        },
      ]
    }
    if (orderResult.errorCode !== SERVICES_RESP.SUCCESS_CODE) {
      let errMsg;
      if (orderResult.errorCode === SERVICES_RESP.QTY_ERROR_CODE) {
        errMsg = language[orderResult.errorCode].format(instrumentInfo.lotsize);
      } else {
        errMsg = orderResult.errorMessage
      }
      const reasonsList = orderResult.reasonsList;
      let reasons = [];
      for (let i = 0; i < reasonsList?.length; i++) {
        const item = reasonsList[i];
        if(item.action === 'R'){
          reasons.push(item.reason);
        }else{
          // reason.splice(0,reason.length);
          break;
        }
      }
      this.setState({ failReason: errMsg , errMsgList: reasons})
    } else {
      this.setState({ failReason: '' })
    }
    if(!utilsFunction.isOrderNeedEnterPrice(orderType)){
      orderInformation.map(item => {
        if(item.label === language.common_price){
          item.value = '-';
        }
      })
    }
    this.props.toggleRefreshTable(true)
    this.setState({ orderInformation })
  }

  getOrderStatus() {
    const { currentTradingAccount, language, orderResult } = this.props
    if (currentTradingAccount.clientID) {
      if(!orderResult.orderGroupID){
        return
      }
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.ORDER_GROUP_ID]: orderResult.orderGroupID,
        [PARAMS.LANGUAGE]: language.lang
      }

      this.props.getOrderDetail(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            const orderData = res.result.orderInfoList.length > 0 ? res.result.orderInfoList[0] : '';
            this.setState({ status: orderData.status ? orderData.status : '-' });
          }
        }
      })
    }
  }

  getOrderFees(){
    const {language,currentTradingAccount, orderResult,orderData} = this.props; 
    const {feesList} = orderResult;
    if(feesList && feesList.length > 0){
      this.getOrderFeesDetailed(feesList);
    }else if(!orderResult.errorMessage){
      const {clientID, tradingAccSeq} = currentTradingAccount;
      const {marketID, instrumentID, bs, newPrice, newQty, orderType} = orderResult;
      if(utilsFunction.isOrderNeedEnterPrice(orderType)){
        const params = {
          [PARAMS.CLIENT_ID]: clientID,
          [PARAMS.TRADING_ACCOUNT_ID]: clientID,
          [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
          [PARAMS.LANGUAGE]: language.lang,
          [PARAMS.MARKET_ID]:marketID,
          [PARAMS.INSTRUMENT_ID]:instrumentID,
          [PARAMS.BS]:bs,
          [PARAMS.PRICE]: String(newPrice),
          [PARAMS.QTY]:String(newQty)
        }
        this.props.getOrderFeesAction(params, res => {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.getOrderFeesDetailed(res.result.feesList);
          }
        })
      }
    }
    else{
      const {clientID, tradingAccSeq} = currentTradingAccount;
      const { orderType } = orderResult
      const {marketID, instrumentID, isBuy, price, quantity, } = orderData;
      if(utilsFunction.isOrderNeedEnterPrice(orderType)){
        const params = {
          [PARAMS.CLIENT_ID]: clientID,
          [PARAMS.TRADING_ACCOUNT_ID]: clientID,
          [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
          [PARAMS.LANGUAGE]: language.lang,
          [PARAMS.MARKET_ID]:marketID,
          [PARAMS.INSTRUMENT_ID]:instrumentID,
          [PARAMS.BS]:isBuy ? 'B' : "S",
          [PARAMS.PRICE]: String(price),
          [PARAMS.QTY]:String(quantity)
        }
        this.props.getOrderFeesAction(params, res => {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.getOrderFeesDetailed(res.result.feesList);
            this.computeOrderInformation(this.props.orderData, this.props.orderResult , res.result)
          }
        })
      }
      
    }
  }

  getOrderFeesDetailed(feesList){
    const {language,orderData, orderResult} = this.props; 
    let orderFeesDetailed = [];
    if(feesList.length > 0){
      feesList.map((item,index) => {
        const languageKey = `common_${item.feeName.toLowerCase().replace(' ','_')}`
        orderFeesDetailed.push(
            <div className={classnames('order-information-item')} key={index}>
                <span>{language[languageKey] ? language[languageKey] :item.feeName}</span>
                <span>{orderData.currencyID}&nbsp;{this.orderFeesFormatNumber(item.amount)}</span>
            </div>
        )
      })
      orderFeesDetailed.push(
          <div className={classnames('order-information-item')} key={feesList.length}>
              <span>{language.common_fees_total_amount}</span>
              <span style={{color: '#1996e3'}}>{orderData.currencyID}&nbsp;{this.orderFeesFormatNumber(orderResult.feeAmt)}</span>
          </div>
      )
    }
    this.setState({
      orderFeesDetailed:orderFeesDetailed
    })
  }

  getOrderFeesDetailed(feesList){
    const {language, orderData, orderResult} = this.props; 
    let orderFeesDetailed = [];
    if(feesList.length > 0 && orderData.marketID !== "FUND"){
      feesList.map((item,index) => {
        const languageKey = `common_${item.feeName.toLowerCase().replace(' ','_')}`
        orderFeesDetailed.push(
            <div className={classnames('order-information-item')} key={index}>
                <span>{language[languageKey] ? language[languageKey] :item.feeName}</span>
                <span>{orderData.currencyID}&nbsp;{this.orderFeesFormatNumber(item.amount)}</span>
            </div>
        )
      })
      orderFeesDetailed.push(
          <div className={classnames('order-information-item')} key={feesList.length}>
              <span>{language.common_fees_total_amount}</span>
              <span style={{color: '#1996e3'}}>{orderData.currencyID}&nbsp;{this.orderFeesFormatNumber(orderResult.feeAmt)}</span>
          </div>
      )
    }
    this.setState({
      orderFeesDetailed:orderFeesDetailed
    })
  }

  orderFeesFormatNumber = (amount) => {
    let decimalCount = 2, decimal = ".", thousands = ",";
    amount = parseFloat(amount);
    if (!amount || isNaN(amount) || (amount == '')) {
      amount = 0;
    }
    if (amount === 0) {
      return amount;
    }
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 3 : decimalCount;
    const negativeSign = amount < 0 ? "-" : "";
    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;
    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  }

  componentDidMount() {
    this.getOrderStatus()
    this.computeOrderInformation(this.props.orderData, this.props.orderResult);
    this.getOrderFees();
    // this.handleShowPrice(this.props.orderData);
    if(this.props.mode == ORDER_MODE.CANCEL){
      this.props.closeAllBox(true)
    }
  }

  // componentDidUpdate(prevState){
  //   const {language} = this.props;
  //   const orderType = this.props.orderData.orderType.value;
  //   if(prevState.isShowPrice !== this.state.isShowPrice){
  //     let orderInformations = JSON.parse(JSON.stringify(this.state.orderInformation));
  //     for(let orderInformation of orderInformations){
  //       if(orderInformation.label === language.common_price){
  //         orderInformation.value = '-'
  //         break
  //       }
  //     }
  //     setTimeout(() => {
  //       this.setState({
  //         orderInformation:orderInformations
  //       })
  //     }, 200)
  //   }
  // }

  // handleShowPrice = (data) =>{
  //   if(data.orderType.value === ORDER_TYPE.AT_AUCTION.value || data.orderType.value === ORDER_TYPE.MARKET_ORDER.value){
  //     this.setState({
  //       isShowPrice:false
  //     })
  //   }else{
  //     this.setState({
  //       isShowPrice:true
  //     })
  //   }
  // }

}

OrderConfirmStatusMobile.defaultProps = {
  mode: ''
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    instrumentInfo: state.trade.instrumentInfo
  }),
  dispatch => ({
    toggleRefreshTable: (p) => dispatch({
      type: REFRESH_DATA.ORDER_TABLE,
      value: p
    }),
    getOrderDetail: (p, c) => dispatch(orderActions.getOrderDetailAction(p, c)),
    getOrderFeesAction: (p, res) => dispatch(orderActions.getOrderFeesAction(p, res))
  })
)(OrderConfirmStatusMobile)